<div class="center-children-horizontally">
  <div class="angular-img-wrapper">
    <!-- Attention seekers -->
    <app-angular-img [@zoomInOnEnter]></app-angular-img>
  </div>
</div>